<div class="search-item-container">
  <!--<a *ngIf="item.url.includes('smartbank/case-study')" (click)="downloadFile()" style="cursor:pointer;">
    <div class="search-item-thumbnail" [innerHTML]="item?.thumbnail| safehtml" *ngIf="showThumbnails"></div>
  </a>-->
  <div (click)="downloadFile($event)">
    <a *ngIf="item.url.includes('smartbank/case-study')">
      <div class="search-item-thumbnail" *ngIf="showThumbnails">
        <ng-container *ngIf="item?.thumbnail; else noThumbnail">
          <div [innerHTML]="item.thumbnail | safehtml"></div>
        </ng-container>
        <ng-template #noThumbnail>
          <img [src]="getIcon(item.content)" alt="">
        </ng-template>
      </div>
    </a>
    <!--<a *ngIf="!item.url.includes('smartbank/case-study')" href="{{item.url}}" rel="noopener">
    <div class="search-item-thumbnail" [innerHTML]="item?.thumbnail| safehtml" *ngIf="showThumbnails"></div>
  </a>-->

    <a *ngIf="!item.url.includes('smartbank/case-study')" href="{{item.url}}" rel="noopener">
      <div class="search-item-thumbnail" *ngIf="showThumbnails">
        <ng-container *ngIf="item?.thumbnail; else noThumbnail">
          <div [innerHTML]="item.thumbnail | safehtml"></div>
        </ng-container>
        <ng-template #noThumbnail>
          <img [src]="getIcon(item.content)" alt="">
        </ng-template>
      </div>
    </a>
  </div>


  <div class="search-item-container-text">
    <div class="search-item-title" (click)="downloadFile($event)">
      <a *ngIf="item.url.includes('smartbank/case-study') && (item.source === 'Diamond IP' && item.url === 'https://wb.isg-one.com/diamondip/DB')" style="cursor:pointer;">
        <span [innerHTML]="item.title | safehtml"></span>
      </a>
        <a *ngIf="!item.url.includes('smartbank/case-study') || !item.url.includes('diamondip/download') || !(item.source === 'Diamond IP' && item.url === 'https://wb.isg-one.com/diamondip/DB')" href="{{item.url}}" rel="noopener">
          <span [innerHTML]="item.title | safehtml"></span>
        </a>
      </div>
    
    <div class="search-item-links">
      <div class="search-item-open">
        <!--<a *ngIf="item.url.includes('smartbank/case-study') || item.url.includes('diamondip/download')" (click)="downloadFile()">Open</a>
  <a *ngIf="!item.url.includes('smartbank/case-study')" href="{{item.url}}" rel="noopener">Open</a>-->
        <a *ngIf="item.url.includes('smartbank/case-study') || item.url.includes('diamondip/download') || (item.source === 'Diamond IP' && item.url === 'https://wb.isg-one.com/diamondip/DB')||(item.source === 'Case Studies' && this.item.url === 'https://wb.isg-one.com/casestudy/DB')|| (item.source === 'Shareable IP' &&  this.item.url === 'https://wb.isg-one.com/shareableIp/DB')" (click)="downloadFile($event)">Open</a>
        <a *ngIf="!item.url.includes('smartbank/case-study') && !item.url.includes('diamondip/download') && !(item.source === 'Diamond IP' && item.url === 'https://wb.isg-one.com/diamondip/DB') && !(item.source === 'Case Studies' && this.item.url === 'https://wb.isg-one.com/casestudy/DB') && !(item.source === 'Shareable IP' &&  this.item.url === 'https://wb.isg-one.com/shareableIp/DB')" href="{{item.url}}" rel="noopener" target="_blank">Open</a>

      </div>
      <div class="search-item-openfolder" *ngIf="item.folder">
        <a href="{{item.folder}}" rel="noopener" target="_blank">Open folder</a>
      </div>
      <!--<div (click)="showPreview()" class="search-item-preview" *ngIf="item.sizeNumeric<26214400">--> <!-- Preview only works for files less than 25MB -->
      <!--Preview
      </div>-->
    </div>
    <div class="search-item-details">
      <div class="search-item-date">
        <span class="search-item-details-label">Date: </span>
        <span>{{item.date| datePreference:false}}</span>
      </div>
      <div class="search-item-separator">&nbsp;-&nbsp;</div>
      <div class="search-item-size" *ngIf="item.size">
        <span class="search-item-details-label">Size: </span>
        <span>{{item.size}}</span>
      </div>
      <div class="search-item-separator">&nbsp;-&nbsp;</div>
      <div class="search-item-source">
        <span class="search-item-details-label">Source: </span>
        <span>{{item.source}}</span>
      </div>
      <div class="search-item-separator">&nbsp;-&nbsp;</div>
      <div class="search-item-extension">
        <span class="search-item-details-label">Extension: </span>
        <span>{{item.extension}}</span>
      </div>
    </div>
    <div class="search-item-content" [innerHtml]="item.content | safehtml"></div>
  </div>
</div>

<ng-template #previewtemplate let-modal>
  <app-search-preview [urlDoc]="item.url"></app-search-preview>
</ng-template>
